/* eslint-disable @typescript-eslint/no-unused-vars */
import { useForm } from 'react-hook-form';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { useApi } from '../../../hooks/userApi';
import { estados } from '../../../utils/estadosBrasil';
import React, { useContext } from 'react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  getEstadoFromSigla,
  maskInput,
  useScreenSize,
  validarCEP,
  validateCNPJ,
  validateCPF,
  validateEmail,
} from 'utils/helpers';
import TextInputField from 'components/inputs/TextField/TextField.component';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import { maskCpfCnpj } from 'utils/maskCpfCnpj';
import { ContainerInternoWrapper, ContainerWrapper, FormGlobal } from 'styles/Global.styles';
import { colors } from 'utils/colors';
import { FormCliente } from '@typings/cadastro';

const DetalhesCliente = () => {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction }: any = useContext(LoadingContext);
  const isBreak = useScreenSize(570);

  const api = useApi();
  const schema = z.object({
    nome: z.string().nonempty({ message: 'O nome é obrigatório.' }),
    cpfCNPJ: z.string().refine(
      (value) => {
        if (value.length === 14) {
          return validateCPF(value);
        } else if (value.length === 18) {
          return validateCNPJ(value);
        } else {
          return false;
        }
      },
      { message: 'CPF/CNPJ inválido.' },
    ),
    tipoDocumento: z.string().nonempty('O tipo de documento é obrigatório.'),
    documento: z.string().nonempty('O tipo de documento é obrigatório.'),
    razaoSocial: z.string().nonempty('A razão social é obrigatório.'),
    nomeFantasia: z.string().nonempty('O nome fantasia é obrigatório.'),
    endereco: z.string().nullable().optional(),
    bairro: z.string().nullable().optional(),
    numero: z.string().nullable().optional(),
    complemento: z.string().nullable().optional(),
    cep: z.string().nullable().optional(),
    cidade: z.string().nullable().optional(),
    estado: z.string().refine(
      (value) => {
        if (value !== '*' && value.length > 0) {
          return true;
        } else {
          return true;
        }
      },
      { message: 'O estado é obrigatório.' },
    ),
    email: z.string().refine(
      (value) => {
        if (validateEmail(value)) {
          return true;
        } else {
          return false;
        }
      },
      { message: 'O email é obrigatório ou está inválido' },
    ),
    telefone: z.string().nonempty('O telefone é obrigatório.'),
    whatsapp: z.string().nullable().optional(),
  });

  const { clearErrors, handleSubmit, setValue, formState, watch } = useForm({
    defaultValues: {
      nome: '',
      cpfCNPJ: '',
      tipoDocumento: '',
      documento: '',
      razaoSocial: '',
      nomeFantasia: '',
      endereco: '',
      bairro: '',
      numero: '',
      complemento: '',
      cep: '',
      cidade: '',
      estado: '*',
      email: '',
      telefone: '',
      whatsapp: '',
    },
    resolver: zodResolver(schema),
  });

  async function buscarCEP(cep) {
    cep = cep.replace(/[^\d]/g, '');
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data && !data.erro) {
        setValue('cidade', data.localidade);
        setValue('endereco', data.logradouro);
        setValue('bairro', data.bairro);
        setValue('estado', getEstadoFromSigla(data.uf));
        clearErrors('cidade');
        clearErrors('endereco');
        clearErrors('bairro');
        clearErrors('estado');
      } else if (data && data.erro) {
        setValue('cidade', '');
        setValue('endereco', '');
        setValue('bairro', '');
      }
    } catch (error) {
      console.error('Erro ao buscar o CEP:', cep, error);
    }
  }

  function handleChange(name: FormCliente, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;

    if (name === 'cpfCNPJ' && value.length > 18) {
      return;
    }

    setValue(name, value);

    if (formState.errors[`${name}`]) {
      clearErrors(name);
    }

    if (name === 'cep' && validarCEP(value)) {
      buscarCEP(value);
    }
  }

  const onSubmit = async (data) => {
    console.log(data);
    setLoading(true);
    data.vendedor = JSON.parse(sessionStorage.getItem('user'));
    try {
      const resposta = await api.post('cliente', data);
      if (resposta.status === false) {
        setLoadingMensagem(resposta.mensagem);
        setLoadingBtn('OK');
      } else {
        setLoadingMensagem('Cliente cadastrado com sucesso.');
        setLoadingAction('/vendedor/calculoProduto/' + resposta.id);
        setLoadingBtn('OK');
      }
    } catch (e) {
      let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      if (e.response.data.message === 'Unauthorized') {
        msg = 'Usuário não autorizado';
        setLoadingAction('/admin/sair');
      }

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  const dadosForm = [
    { label: 'Nome do Cliente', type: 'text', campo: 'nome', select: false, option: [] },
    { label: 'CPF/CNPJ', type: 'text', campo: 'cpfCNPJ', select: false, option: [] },
    { label: 'Tipo Documento', type: 'text', campo: 'tipoDocumento', select: false, option: [] },
    { label: 'Documento', type: 'text', campo: 'documento', select: false, option: [] },
    { label: 'Razão Social', type: 'text', campo: 'razaoSocial', select: false, option: [] },
    { label: 'Nome Fantasia', type: 'text', campo: 'nomeFantasia', select: false, option: [] },
    { label: 'CEP', type: 'text', campo: 'cep', select: false, option: [] },
    { label: 'Endereço', type: 'text', campo: 'endereco', select: false, option: [] },
    { label: 'Bairro', type: 'text', campo: 'bairro', select: false, option: [] },
    { label: 'Cidade', type: 'text', campo: 'cidade', select: false, option: [] },
    { label: 'Estado', type: 'text', campo: 'estado', select: true, option: estados },
    { label: 'Número', type: 'text', campo: 'numero', select: false, option: [] },
    { label: 'Complemento', type: 'text', campo: 'complemento', select: false, option: [] },
    { label: 'E-mail', type: 'text', campo: 'email', select: false, option: [] },
    { label: 'Telefone', type: 'text', campo: 'telefone', select: false, option: [] },
    { label: 'Whatsapp', type: 'text', campo: 'whatsapp', select: false, option: [] },
  ];

  const isCampoInFormCliente = (campo: string): campo is FormCliente => {
    return (
      campo === 'nome' ||
      campo === 'cpfCNPJ' ||
      campo === 'tipoDocumento' ||
      campo === 'documento' ||
      campo === 'razaoSocial' ||
      campo === 'nomeFantasia' ||
      campo === 'endereco' ||
      campo === 'bairro' ||
      campo === 'numero' ||
      campo === 'complemento' ||
      campo === 'cep' ||
      campo === 'cidade' ||
      campo === 'estado' ||
      campo === 'email' ||
      campo === 'telefone' ||
      campo === 'whatsapp'
    );
  };

  const hanldeGetDisable = (value: string) => {
    switch (value) {
      case 'cidade':
        return true;
      case 'estado':
        return true;
      case 'endereco':
        return true;
      default:
        return false;
    }
  };

  return (
    <FormGlobal noValidate onSubmit={handleSubmit(onSubmit)}>
      {dadosForm &&
        dadosForm.map((dados, index) => (
          <>
            <TextInputField
              key={index}
              label={dados.label}
              type={dados.type}
              selected={dados.select}
              nome={dados.campo}
              dados={dados.option}
              mask={maskInput(dados.campo)}
              style={{ width: isBreak ? '100%' : '49%' }}
              defaultValueText={'-- Selecione --'}
              // disabled={hanldeGetDisable(dados.campo)}
              value={
                isCampoInFormCliente(dados.campo)
                  ? dados.campo === 'cpfCNPJ'
                    ? maskCpfCnpj(watch(dados.campo))
                    : watch(dados.campo)
                  : null
              }
              error={!!formState.errors[dados.campo]}
              helperText={formState.errors[dados.campo] ? formState.errors[dados.campo].message : ''}
              onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
            />
          </>
        ))}
      <div style={{ marginTop: '30px' }}>
        <ButtonPrimary typeSubmit label={'finalizar cadastro'} />
      </div>
    </FormGlobal>
  );
};

const CadastroCliente = () => {
  return (
    <ContainerWrapper>
      <ContainerInternoWrapper>
        <p style={{ color: colors.verde, fontSize: '1.25rem', fontWeight: 600 }}>DADOS DO CLIENTE</p>
        <DetalhesCliente />
      </ContainerInternoWrapper>
    </ContainerWrapper>
  );
};

export default CadastroCliente;
